import React, { Component } from 'react';
import { useTheme } from '@mui/material/styles';
import { ResponsiveContainer } from 'recharts';
import Grid from '@mui/material/Grid';
import GaugeChart from 'react-gauge-chart'
import Title from '../Title';


function generateRandomInteger(min, max) {
    return Math.round(
        (Math.random() * (max - min) + min) * 100,
      ) / 100
  }


class TempGauge extends Component {
    constructor(props) {
        super(props);
        this.state = {
            percent: this.props.min,
            min: this.props.min,
            max: this.props.max,
            measurement: `${'\u00b0'}C`
        }
    }

   
    componentDidMount() {

        this.interval = setInterval(
            () =>                
                this.setState({
                    percent: generateRandomInteger(this.props.min, this.props.max)                    
                })                
            , 1000
        )               
    };

    componentWillUnmount() {
        clearInterval(this.interval);

    }

    render() {
        console.log(this.state.percent )
        return (            
            <div>
                <Grid spacing={0}>
                    <Grid item xs={12}>
                        <h2>{this.props.name}</h2>
                    </Grid>
                    <Grid item xs={12}>
                        <ResponsiveContainer>

                        <GaugeChart id="gauge-chart4"
                            style={{ width: "300px" }}
                            animate={false} 
                            nrOfLevels={10}
                            arcPadding={0.1}
                            cornerRadius={3}
                            percent={this.state.percent}
                            formatTextValue={value => value + this.state.measurement}
                            textColor="#000000"
                        />

                        </ResponsiveContainer>
                    </Grid>

                </Grid>
            </div>
        );
    }
}

export default TempGauge;